import projectConfig, { PROJECT } from '~/projects/config';
import { ProductType, REGULARITY } from '~/types/product';

export enum PRODUCT_TAG {
  FREEMIUM_DETECTOR_LIMIT = 'freemium_detectors_limit',
  EXCLUDE_DETECTORS = 'exclude_detectors',
}

export const ANNUAL_PLAN_OLD_PRICE = `600.00 USD`;
export const ANNUAL_PLAN_DISCOUNT = `500.00 USD`;
export const ANNUAL_PLAN_DISCOUNT_PERCENT = 200;

type ProductsConfig = {
  ONETIME_DETECTORS_10_DOLLARS_10K_WORDS_ID: string;
  ONETIME_DETECTORS_20_DOLLARS_20K_WORDS_ID: string;
  ONETIME_DETECTORS_40_DOLLARS_50K_WORDS_ID: string;
  ONETIME_DETECTORS_80_DOLLARS_100K_WORDS_ID: string;
  ANNUAL_SUB_OFFER_ID: string;
  MONTHLY_SUB_OFFER_ID: string;
  UNBLOCK_DETECTOR_TOOLS_10_DOLLARS_ID?: string;
  ANNUAL_SUB_OFFER_80_USD_365_DAYS_ID: string;
  SUB_NOT_FOUND_PRODUCTS: ProductType[];
};

const productsConfigByProject = {
  [PROJECT.JUSTDONE]: {
    ONETIME_DETECTORS_10_DOLLARS_10K_WORDS_ID:
      '7649b99f-ac67-4203-814a-245ba3d61a2d',
    ONETIME_DETECTORS_20_DOLLARS_20K_WORDS_ID:
      'dd3cde1a-1193-43de-a666-73eb3d06597d',
    ONETIME_DETECTORS_40_DOLLARS_50K_WORDS_ID:
      '52f2c29e-db41-4c4a-b1f2-e6ced91487c3',
    ONETIME_DETECTORS_80_DOLLARS_100K_WORDS_ID:
      'db7b5e57-1ea6-46f0-b0bf-efa7613405c9',
    ANNUAL_SUB_OFFER_ID: 'ce6e8796-b540-434a-a45b-b783a872f897',
    ANNUAL_SUB_OFFER_80_USD_365_DAYS_ID: 'c3488e95-7058-42b6-b3a0-ac111b7958cc',
    MONTHLY_SUB_OFFER_ID: '2b689ff3-6ad5-458c-8f4c-49c77ff82d92',
    UNBLOCK_DETECTOR_TOOLS_10_DOLLARS_ID:
      'ec2d5585-a1e2-4956-b528-e70479300f7e',
    SUB_NOT_FOUND_PRODUCTS: [
      {
        subscription_type: '',
        trial_currency: '',
        id: 'c28311f2-b8fb-4cca-8f21-cba1409d6b70',
        name: 'Unlimited Annual Plan',
        is_solid: true,
        has_trial_period: false,
        regularity: REGULARITY.YEAR,
        price: 29900,
        currency: 'USD',
        trial_period: 0,
        trial_amount: 0,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 365,
        // @ts-ignore
        description: 'Justdone.ai Annual Subscription \n(support@justdone.ai)',
        is_unlimited: true,
        solid_name_for_bi: 'Justdone_plan_299_usd_365days',
        new_price_ui: 2499,
        old_price_ui: 4999,
        discount_percentage_ui: 50,
        regularity_ui: REGULARITY.MONTH,
        description_ui: 'Annual Plan without any limits',
        details_ui: 'Annual fee $299 ($24.99 per month) for unlimited usage',
        is_popular_ui: true,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: '',
        tags: ['best_price'],
      },
      {
        subscription_type: '',
        trial_currency: '',
        id: 'f9c3b0b0-ed5a-4911-b4cb-4facb7ed9290',
        name: '7-day Access Plan',
        is_solid: true,
        has_trial_period: true,
        regularity: REGULARITY.MONTH,
        price: 3999,
        currency: 'USD',
        trial_period: 7,
        trial_amount: 200,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 30,
        // @ts-ignore
        description: 'Justdone.ai: Monthly subscription.',
        is_unlimited: true,
        solid_name_for_bi: 'Justdone_plan_39.99_usd_30days_2_trial',
        new_price_ui: 3999,
        old_price_ui: 3999,
        discount_percentage_ui: 0,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: false,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: 'Unlimited Monthly Plan',
        tags: [],
      },
      {
        subscription_type: '',
        trial_currency: '',
        id: 'c61cfe9e-b9d8-41f5-9ccb-a39505ef3e11',
        name: 'Unlimited Monthly Plan',
        is_solid: true,
        has_trial_period: false,
        regularity: REGULARITY.MONTH,
        price: 2999,
        currency: 'USD',
        trial_period: 0,
        trial_amount: 0,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 30,
        // @ts-ignore
        description: 'Justdone.ai Monthly Subscription \n(support@justdone.ai)',
        is_unlimited: true,
        solid_name_for_bi: 'Justdone_plan_29.99_usd_30days',
        new_price_ui: 2999,
        old_price_ui: 6999,
        discount_percentage_ui: 0,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: true,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: '',
        tags: [],
      },
    ],
  },
  [PROJECT.SIDEKICKER]: {
    ONETIME_DETECTORS_10_DOLLARS_10K_WORDS_ID:
      '9293b1ad-947d-44da-9323-8c57fb72f92a',
    ONETIME_DETECTORS_20_DOLLARS_20K_WORDS_ID:
      '3ee8f247-4a54-42dc-bd90-2e39c6192578',
    ONETIME_DETECTORS_40_DOLLARS_50K_WORDS_ID:
      '3f302aba-26b3-488b-bca3-8ee8e642a717',
    ONETIME_DETECTORS_80_DOLLARS_100K_WORDS_ID:
      'd2a28674-a952-463f-882e-4d8d0cd3b97d',
    ANNUAL_SUB_OFFER_ID: '20f0b844-429c-4e06-883b-080c86bb224b',
    // FIXME: this is a justdone plan
    MONTHLY_SUB_OFFER_ID: '2b689ff3-6ad5-458c-8f4c-49c77ff82d92',
    ANNUAL_SUB_OFFER_80_USD_365_DAYS_ID: 'f885a082-617f-472f-8490-7feb33b49a82',
    UNBLOCK_DETECTOR_TOOLS_10_DOLLARS_ID: '',
    SUB_NOT_FOUND_PRODUCTS: [
      {
        subscription_type: '',
        trial_currency: '',
        id: '84bf22af-14a0-48d5-87b5-9be0469daa15',
        name: 'Unlimited Annual Plan',
        is_solid: true,
        has_trial_period: false,
        regularity: REGULARITY.YEAR,
        price: 19999,
        currency: 'USD',
        trial_period: 0,
        trial_amount: 0,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 365,
        // @ts-ignore
        description:
          'Sidekicker.ai Annual Subscription \n(support@sidekicker.ai)',
        is_unlimited: true,
        solid_name_for_bi: 'Justdone_plan_199_usd_365days_VAT_SK',
        new_price_ui: 1666,
        old_price_ui: 3333,
        discount_percentage_ui: 50,
        regularity_ui: REGULARITY.MONTH,
        description_ui: 'Annual Plan without any limits',
        details_ui: 'Annual fee $299 ($24.99 per month) for unlimited usage',
        is_popular_ui: true,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: '',
        tags: ['best_price'],
      },
      {
        subscription_type: '',
        trial_currency: '',
        id: 'a13c7c66-4595-4020-b35a-9e9ae3a81049',
        name: '7-day Access Plan',
        is_solid: true,
        has_trial_period: true,
        regularity: REGULARITY.MONTH,
        price: 3499,
        currency: 'USD',
        trial_period: 7,
        trial_amount: 195,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 30,
        // @ts-ignore
        description:
          'Sidekicker.ai Monthly Subscription \n(support@sidekicker.ai)',
        is_unlimited: true,
        solid_name_for_bi: 'Justdone_plan_34.99_usd_30days_1.95_trial_VAT_SK',
        new_price_ui: 3499,
        old_price_ui: 3499,
        discount_percentage_ui: 0,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: false,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: 'Unlimited Monthly Plan',
        tags: [],
      },
      {
        subscription_type: '',
        trial_currency: '',
        id: '3e34a466-916e-46e0-bdd1-cbdd46a0fcb4',
        name: 'Unlimited Monthly Plan',
        is_solid: true,
        has_trial_period: false,
        regularity: REGULARITY.MONTH,
        price: 2499,
        currency: 'USD',
        trial_period: 0,
        trial_amount: 0,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 30,
        // @ts-ignore
        description:
          'Sidekicker.ai Monthly Subscription \n(support@sidekicker.ai)',
        is_unlimited: true,
        solid_name_for_bi: 'Justdone_plan_24.99_usd_30days_VAT_SK',
        new_price_ui: 2499,
        old_price_ui: 6999,
        discount_percentage_ui: 0,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: true,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: '',
        tags: [],
      },
    ],
  },
  [PROJECT.POLYLLM_CHAT]: {
    // TODO(polyllm-pricing): PolyLLM does not have one-time/detector products;
    // these IDs are placeholders reused from JustDone so the shared config shape is satisfied.
    ONETIME_DETECTORS_10_DOLLARS_10K_WORDS_ID:
      '7649b99f-ac67-4203-814a-245ba3d61a2d',
    ONETIME_DETECTORS_20_DOLLARS_20K_WORDS_ID:
      'dd3cde1a-1193-43de-a666-73eb3d06597d',
    ONETIME_DETECTORS_40_DOLLARS_50K_WORDS_ID:
      '52f2c29e-db41-4c4a-b1f2-e6ced91487c3',
    ONETIME_DETECTORS_80_DOLLARS_100K_WORDS_ID:
      'db7b5e57-1ea6-46f0-b0bf-efa7613405c9',
    ANNUAL_SUB_OFFER_ID: 'ce6e8796-b540-434a-a45b-b783a872f897',
    ANNUAL_SUB_OFFER_80_USD_365_DAYS_ID: 'c3488e95-7058-42b6-b3a0-ac111b7958cc',
    MONTHLY_SUB_OFFER_ID: '2b689ff3-6ad5-458c-8f4c-49c77ff82d92',
    UNBLOCK_DETECTOR_TOOLS_10_DOLLARS_ID:
      'ec2d5585-a1e2-4956-b528-e70479300f7e',
    SUB_NOT_FOUND_PRODUCTS: [
      {
        subscription_type: '',
        trial_currency: '',
        id: 'db0809e6-cf9a-4044-b65f-15960844c378',
        name: 'Annual Plan',
        is_solid: true,
        has_trial_period: false,
        regularity: REGULARITY.YEAR,
        price: 12000,
        currency: 'USD',
        trial_period: 0,
        trial_amount: 0,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 365,
        // @ts-ignore
        description: 'PolyLLM Annual Subscription',
        is_unlimited: true,
        solid_name_for_bi: 'ChatwithAI_plan_120_usd_365days_VAT',
        new_price_ui: 999,
        old_price_ui: 1999,
        discount_percentage_ui: 50,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: false,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: '',
        tags: ['best_price'],
      },
      {
        subscription_type: '',
        trial_currency: '',
        id: '2ea46ead-7376-44cd-81e2-c8ebce373fc9',
        name: 'Monthly Plan',
        is_solid: true,
        has_trial_period: false,
        regularity: REGULARITY.MONTH,
        price: 1999,
        currency: 'USD',
        trial_period: 0,
        trial_amount: 0,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 30,
        // @ts-ignore
        description: 'PolyLLM Monthly Subscription',
        is_unlimited: true,
        solid_name_for_bi: 'ChatwithAI_plan_19.99_usd_30days_VAT',
        new_price_ui: 1999,
        old_price_ui: 1999,
        discount_percentage_ui: 0,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: true,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: '',
        tags: [],
      },
      {
        subscription_type: '',
        trial_currency: '',
        id: '189f12ae-6930-4e05-af86-52f8994b8e09',
        name: '7-day Access Plan',
        is_solid: true,
        has_trial_period: true,
        regularity: REGULARITY.MONTH,
        price: 3999,
        currency: 'USD',
        trial_period: 7,
        trial_amount: 200,
        created_at: '2024-01-08T14:50:13Z',
        updated_at: '2024-01-08T14:50:13Z',
        billing_period: 30,
        // @ts-ignore
        description: 'PolyLLM 7-day Access Subscription',
        is_unlimited: true,
        solid_name_for_bi: 'ChatwithAI_plan_39.99_usd_30days_2_trial_VAT',
        new_price_ui: 3999,
        old_price_ui: 3999,
        discount_percentage_ui: 0,
        regularity_ui: REGULARITY.MONTH,
        description_ui: '',
        details_ui: '',
        is_popular_ui: false,
        // @ts-ignore
        bi_is_upsell: false,
        alternative_non_trial_name: 'Monthly Plan',
        tags: [],
      },
    ],
  },
} satisfies Readonly<Partial<Record<PROJECT, ProductsConfig>>>;

export const PRODUCTS_PROJECT_CONFIG =
  productsConfigByProject[projectConfig.project] ||
  productsConfigByProject[PROJECT.JUSTDONE];
